import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CHorasExtras extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	form = {
		overTime: '',
		aliquotPatronal: 20,
		aliquotS: 5.8,
		aliquotRAT: 3,
		months: 60,
	}

	advanced = {
		selic: 1.25,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	get aliquot() {
		return (
			this.form.aliquotPatronal +
			this.form.aliquotS +
			this.form.aliquotRAT
		)
	}

	get monthlySavings() {
		const overTimeInt = parseFloat(
			this.form.overTime.replaceAll('.', '').replaceAll(',', '.'),
		)
		const result = this.parse(overTimeInt * (this.aliquot / 100))
		this.$emit('savings', result)

		return currencyFormat(result)
	}

	get recuperateOn() {
		const monthlySavings = parseFloat(
			this.monthlySavings.replaceAll('.', '').replaceAll(',', '.'),
		)
		const result = this.parse(
			monthlySavings * this.form.months * this.advanced.selic,
		)
		this.$emit('recuperate', result)

		return currencyFormat(result)
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(2))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.overTime = this.form.overTime
			found.aliquotPatronal = this.form.aliquotPatronal
			found.aliquotS = this.form.aliquotS
			found.aliquotRAT = this.form.aliquotRAT
			found.months = this.form.months
			found.selic = this.advanced.selic
		} else {
			this.calcsEach.unshift({
				id: this.id,
				aliquotPatronal: this.form.aliquotPatronal,
				aliquotS: this.form.aliquotS,
				aliquotRAT: this.form.aliquotRAT,
				overTime: this.form.overTime,
				months: this.form.months,
				selic: this.advanced.selic,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'Custo de horas extras',
						value: this.form.overTime,
					},
					{
						label: 'Alíquota Cota Patronal',
						value: this.form.aliquotPatronal + ' %',
					},
					{
						label: 'Alíquota Sistema S',
						value: this.form.aliquotS + ' %',
					},
					{
						label: 'Alíquota RAT',
						value: this.form.aliquotRAT + ' %',
					},
				],
				[
					{
						label: 'Economia Mensal',
						value: 'R$ ' + this.monthlySavings,
						colSpan: 2,
					},
					{},
					{
						label: 'Recuperação em ' + this.form.months + ' meses',
						value: 'R$ ' + this.recuperateOn,
						colSpan: 2,
					},
					{},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.recuperateOn
			found.savings = this.monthlySavings
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'Não incidência de contribuição previdenciária sobre horas extras',
				color: this.color,
				columns: 4,
				rows: rows(),
				type: 'table',
				recuperate: this.recuperateOn,
				savings: this.monthlySavings,
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.form.aliquotPatronal = found.aliquotPatronal
			this.form.aliquotS = found.aliquotS
			this.form.aliquotRAT = found.aliquotRAT
			this.form.months = found.months
			this.form.overTime = found.overTime
			this.advanced.selic = found.selic
		}
	}
}
